import { TMInvoiceScheduleAPI } from '@business/api/tm_invoice_schedule';
import { TimeMaterialId } from '@business/entities/tm';
import { TMInvoiceScheduleId, TMInvoiceScheduleResponse } from '@business/entities/tm/TMInvoiceScheduleResponse';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { TMInvoiceScheduleFormData } from '@modules/timeMaterials/TimeMaterialOverlay/Tabs/Order/AddEditTMInvoiceScheduleModal/AddEditTMInvoiceScheduleModal';
import { switchMap } from 'rxjs/operators';

export class TMInvoiceScheduleBloc extends BaseBloc {
  private readonly typeRepo = new Repository<TMInvoiceScheduleResponse>({
    getItemId: item => item.id,
  });

  readonly tmInvoiceSchedules$ = this.typeRepo.items$;
  readonly selectTMInvoiceSchedule = this.typeRepo.selectItem;

  onReset() {
    this.typeRepo.reset();
  }

  fetchInvoices = (tmId?: TimeMaterialId) => {
    return TMInvoiceScheduleAPI.fetchInvoices(tmId).pipe(
      this.typeRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_invoice_schedule_error') }),
    );
  };

  fetchInvoice = (id: TMInvoiceScheduleId) => {
    return TMInvoiceScheduleAPI.fetchInvoice(id).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_invoice_schedule_error') }),
    );
  };

  createInvoice = (data: TMInvoiceScheduleFormData) => {
    return TMInvoiceScheduleAPI.createInvoice(data).pipe(
      this.typeRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_invoice_schedule'),
      }),
    );
  };

  updateInvoice = (id: TMInvoiceScheduleId, data: TMInvoiceScheduleFormData) => {
    return TMInvoiceScheduleAPI.updateInvoice(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_invoice_schedule'),
      }),
    );
  };

  updateScheduleInvoiceDueDate = (id: TMInvoiceScheduleId, data: Partial<TMInvoiceScheduleResponse>) => {
    return TMInvoiceScheduleAPI.updateScheduleInvoiceDueDate(id, data).pipe(
      this.typeRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_invoice_schedule'),
      }),
    );
  };

  deleteInvoice = (id: TMInvoiceScheduleId) => {
    return showDeleteConfirmation('Delete Inovice Schedule', 'Do you really want to remove this Inovice Schedule?').pipe(
      switchMap(() => TMInvoiceScheduleAPI.deleteInvoice(id)),
      this.typeRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_invoice_schedule'),
      }),
    );
  };

  payInvoice = (data: any) => {
    return TMInvoiceScheduleAPI.payInvoice(data).pipe(
      handleMessage({
        type: requestMessage('pay_invoice_schedule'),
      }),
    );
  };
}
